import { render, staticRenderFns } from "./ViewPurchaseOrder.vue?vue&type=template&id=1ef23d96&scoped=true&"
import script from "./ViewPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./ViewPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewPurchaseOrder.vue?vue&type=style&index=0&id=1ef23d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef23d96",
  null
  
)

export default component.exports